import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Role } from '../types/role.enum';

export interface NavigationItem {
  id: string;
  label: string;
  icon?: string;
  route?: string;
  action?: () => void;
  badge?: string | number;
  disabled?: boolean;
  children?: NavigationItem[];
  role?: Role;
  expanded?: boolean;
  sectionHeader?: string;
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private router = inject(Router);
  private navigationItems$ = new BehaviorSubject<NavigationItem[]>([]);
  private isCollapsed$ = new BehaviorSubject<boolean>(false);
  getNavigationItems(): Observable<NavigationItem[]> {
    return this.navigationItems$.asObservable();
  }

  setNavigationItems(items: NavigationItem[]): void {
    this.navigationItems$.next(items);
  }

  getCollapseState(): Observable<boolean> {
    return this.isCollapsed$.asObservable();
  }

  toggleCollapse(): void {
    this.isCollapsed$.next(!this.isCollapsed$.value);
  }

  setCollapse(collapsed: boolean): void {
    this.isCollapsed$.next(collapsed);
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

  executeAction(action?: () => void): void {
    if (action) {
      action();
    }
  }

  isActive(route?: string): boolean {
    if (!route) return false;
    console.log('Current URL:', this.router.url, 'Checking against route:', route);
    return this.router.url === route || this.router.url.startsWith(route + '/');
  }

  findItemById(id: string, items?: NavigationItem[]): NavigationItem | null {
    const searchItems = items || this.navigationItems$.value;

    for (const item of searchItems) {
      if (item.id === id) {
        return item;
      }
      if (item.children) {
        const found = this.findItemById(id, item.children);
        if (found) return found;
      }
    }
    return null;
  }
}